import { render, staticRenderFns } from "./ExchangeCreate.vue?vue&type=template&id=33c40a07&"
import script from "./ExchangeCreate.vue?vue&type=script&lang=js&"
export * from "./ExchangeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports